






import { Component, Vue } from 'vue-property-decorator';
import OffsetCard from '@/components/widget/OffsetCard.vue';
import DemoSocket from '@/views/demo/DemoSocket.vue';
import DemoOrg from '@/views/demo/DemoOrg.vue';
import DemoSort from './DemoSort.vue';

@Component({
  components: { OffsetCard, DemoSocket, DemoOrg, DemoSort },
})
export default class Demo extends Vue {}
